import { render } from "./NavbarElement.vue?vue&type=template&id=8b0652ee&scoped=true"
import script from "./NavbarElement.vue?vue&type=script&lang=js"
export * from "./NavbarElement.vue?vue&type=script&lang=js"

import "./NavbarElement.vue?vue&type=style&index=0&id=8b0652ee&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0652ee"]])

export default __exports__